export const environmentversion = {
  version : 'detached(100eddc6fd3419114cef5a1274e064b97aa28ce7)'
};